module.exports = BMap;


//////////////////
// WEBPACK FOOTER
// external "BMap"
// module id = 3156
// module chunks = 